/* PDP flash-sale badge T&Cs tooltip. Desktop opens it on hover / focus (CSS only);
   mobile has no hover, so a tap toggles it here. Delegated so it keeps working when
   the badges row is re-rendered (variant change) or injected by quick-add. */

/* Wrapped in an IIFE + guard: this file can be loaded twice (PDP section and quick-add modal) */
(() => {
  if (window.__hmPdpFlashTooltipLoaded) return;
  window.__hmPdpFlashTooltipLoaded = true;

  const OPEN_CLASS = 'hm-pdp-flash--open';

  /** @param {Element | null} [except] */
  function closeAll(except = null) {
    document.querySelectorAll(`.${OPEN_CLASS}`).forEach((wrap) => {
      if (wrap === except) return;
      wrap.classList.remove(OPEN_CLASS);
      wrap.querySelector('[data-hm-pdp-flash-trigger]')?.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('click', (event) => {
    const target = /** @type {Element} */ (event.target);
    const trigger = target.closest('[data-hm-pdp-flash-trigger]');
    if (!trigger) {
      if (!target.closest('[data-hm-pdp-flash]')) closeAll();
      return;
    }
    const wrap = trigger.closest('[data-hm-pdp-flash]');
    if (!wrap) return;
    const open = !wrap.classList.contains(OPEN_CLASS);
    closeAll(wrap);
    wrap.classList.toggle(OPEN_CLASS, open);
    trigger.setAttribute('aria-expanded', String(open));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeAll();
  });
})();
